import { GrammarCategory } from '../../../../types/types';

export const grammaire: GrammarCategory = {
  'Pronoms sujets': {
    'ⲁⲛⲟⲕ': {
      translation: "Je, moi",
      translationEn: "I, me",
      explanation: "Pronom personnel première personne du singulier",
      explanationEn: "First person singular personal pronoun",
      example: "ⲁⲛⲟⲕ ϯⲛⲁϣⲉ. (Moi, je vais.)",
      exampleEn: "ⲁⲛⲟⲕ ϯⲛⲁϣⲉ. (Me, I am going.)"
    },
    'ⲛⲧⲟⲕ': {
      translation: "Tu, toi (masculin)",
      translationEn: "You, you (masculine)",
      explanation: "Pronom personnel deuxième personne du singulier masculin",
      explanationEn: "Second person singular masculine personal pronoun",
      example: "ⲛⲧⲟⲕ ⲭⲛⲁϣⲉ. (Toi, tu vas.)",
      exampleEn: "ⲛⲧⲟⲕ ⲭⲛⲁϣⲉ. (You, you are going.)"
    },
    'ⲛⲧⲟ': {
      translation: "Tu, toi (féminin)",
      translationEn: "You, you (feminine)",
      explanation: "Pronom personnel deuxième personne du singulier féminin",
      explanationEn: "Second person singular feminine personal pronoun",
      example: "ⲛⲧⲟ ⲧⲉⲛⲁϣⲉ. (Toi, tu vas.)",
      exampleEn: "ⲛⲧⲟ ⲧⲉⲛⲁϣⲉ. (You, you are going.)"
    },
    'ⲛⲧⲟϥ': {
      translation: "Il, lui",
      translationEn: "He, him",
      explanation: "Pronom personnel troisième personne du singulier masculin",
      explanationEn: "Third person singular masculine personal pronoun",
      example: "ⲛⲧⲟϥ ϥⲛⲁϣⲉ. (Lui, il va.)",
      exampleEn: "ⲛⲧⲟϥ ϥⲛⲁϣⲉ. (Him, he is going.)"
    },
    'ⲛⲧⲟⲥ': {
      translation: "Elle",
      translationEn: "She",
      explanation: "Pronom personnel troisième personne du singulier féminin",
      explanationEn: "Third person singular feminine personal pronoun",
      example: "ⲛⲧⲟⲥ ⲥⲛⲁϣⲉ. (Elle, elle va.)",
      exampleEn: "ⲛⲧⲟⲥ ⲥⲛⲁϣⲉ. (Her, she is going.)"
    },
    'ⲁⲛⲟⲛ': {
      translation: "Nous",
      translationEn: "We",
      explanation: "Pronom personnel première personne du pluriel",
      explanationEn: "First person plural personal pronoun",
      example: "ⲁⲛⲟⲛ ⲧⲉⲛⲛⲁϣⲉ. (Nous, nous allons.)",
      exampleEn: "ⲁⲛⲟⲛ ⲧⲉⲛⲛⲁϣⲉ. (Us, we are going.)"
    },
    'ⲛⲧⲱⲧⲉⲛ': {
      translation: "Vous",
      translationEn: "You (plural)",
      explanation: "Pronom personnel deuxième personne du pluriel",
      explanationEn: "Second person plural personal pronoun",
      example: "ⲛⲧⲱⲧⲉⲛ ⲧⲉⲧⲉⲛⲛⲁϣⲉ. (Vous, vous allez.)",
      exampleEn: "ⲛⲧⲱⲧⲉⲛ ⲧⲉⲧⲉⲛⲛⲁϣⲉ. (You, you are going.)"
    },
    'ⲛⲧⲱⲟⲩ': {
      translation: "Ils/Elles",
      translationEn: "They",
      explanation: "Pronom personnel troisième personne du pluriel",
      explanationEn: "Third person plural personal pronoun",
      example: "ⲛⲧⲱⲟⲩ ⲥⲉⲛⲁϣⲉ. (Eux/Elles, ils/elles vont.)",
      exampleEn: "ⲛⲧⲱⲟⲩ ⲥⲉⲛⲁϣⲉ. (Them, they are going.)"
    }
  },
  'Conjugaison present': {
    'ϯⲥⲱⲧⲉⲙ': {
      translation: "J'écoute",
      translationEn: "I listen",
      explanation: "Forme du présent à la première personne du singulier",
      explanationEn: "Present tense form, first person singular",
      example: "ϯⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ (J'écoute la parole)",
      exampleEn: "ϯⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ (I listen to the word)"
    },
    'ⲕⲥⲱⲧⲉⲙ': {
      translation: "Tu écoutes (masculin)",
      translationEn: "You listen (masculine)",
      explanation: "Forme du présent à la deuxième personne du singulier masculin",
      explanationEn: "Present tense form, second person singular masculine",
      example: "ⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ (Tu écoutes le maître)",
      exampleEn: "ⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ (You listen to the teacher)"
    },
    'ϥⲥⲱⲧⲉⲙ': {
      translation: "Il écoute",
      translationEn: "He listens",
      explanation: "Forme du présent à la troisième personne du singulier masculin",
      explanationEn: "Present tense form, third person singular masculine",
      example: "ϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ (Il écoute le chant)",
      exampleEn: "ϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ (He listens to the song)"
    }
  },
  'Conjugaison passe': {
    'ⲁⲓⲥⲱⲧⲉⲙ': {
      translation: "J'ai écouté",
      translationEn: "I listened",
      explanation: "Passé accompli à la première personne du singulier",
      explanationEn: "Completed past tense, first person singular",
      example: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ (J'ai écouté la parole)",
      exampleEn: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ (I listened to the word)"
    },
    'ⲁⲕⲥⲱⲧⲉⲙ': {
      translation: "Tu as écouté (masculin)",
      translationEn: "You listened (masculine)",
      explanation: "Passé accompli à la deuxième personne du singulier masculin",
      explanationEn: "Completed past tense, second person singular masculine",
      example: "ⲁⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ (Tu as écouté le maître)",
      exampleEn: "ⲁⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ (You listened to the teacher)"
    },
    'ⲁϥⲥⲱⲧⲉⲙ': {
      translation: "Il a écouté",
      translationEn: "He listened",
      explanation: "Passé accompli à la troisième personne du singulier masculin",
      explanationEn: "Completed past tense, third person singular masculine",
      example: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ (Il a écouté le chant)",
      exampleEn: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ (He listened to the song)"
    }
  },
  'Prepositions base': {
    'ϧⲉⲛ': {
      translation: "Dans, en",
      translationEn: "In",
      explanation: "Préposition de lieu indiquant la position",
      explanationEn: "Preposition of place indicating position",
      example: "ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ (Dans l'église)",
      exampleEn: "ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ (In the church)"
    },
    'ⲉ': {
      translation: "Vers, à",
      translationEn: "Toward, to",
      explanation: "Préposition de direction",
      explanationEn: "Preposition of direction",
      example: "ⲉ ϯⲉⲕⲕⲗⲏⲥⲓⲁ (Vers l'église)",
      exampleEn: "ⲉ ϯⲉⲕⲕⲗⲏⲥⲓⲁ (Toward the church)"
    },
    'ϩⲓ': {
      translation: "Sur",
      translationEn: "On",
      explanation: "Préposition de position",
      explanationEn: "Preposition of position",
      example: "ϩⲓ ⲡⲓⲙⲱⲓⲧ (Sur le chemin)",
      exampleEn: "ϩⲓ ⲡⲓⲙⲱⲓⲧ (On the path)"
    }
  },
  'Adjectifs qualificatifs': {
    'ⲁⲅⲁⲑⲟⲥ': {
      translation: "Bon, bonne",
      translationEn: "Good",
      explanation: "Adjectif qualificatif positif",
      explanationEn: "Positive qualifying adjective",
      example: "ⲟⲩⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ (Un homme bon)",
      exampleEn: "ⲟⲩⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ (A good man)"
    },
    'ⲛⲓϣϯ': {
      translation: "Grand, grande",
      translationEn: "Big, large",
      explanation: "Adjectif de taille",
      explanationEn: "Adjective of size",
      example: "ⲟⲩⲏⲓ ⲛ̀ⲛⲓϣϯ (Une grande maison)",
      exampleEn: "ⲟⲩⲏⲓ ⲛ̀ⲛⲓϣϯ (A big house)"
    },
    'ⲕⲟⲩϫⲓ': {
      translation: "Petit, petite",
      translationEn: "Small, little",
      explanation: "Adjectif de taille",
      explanationEn: "Adjective of size",
      example: "ⲟⲩⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ (Un petit enfant)",
      exampleEn: "ⲟⲩⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ (A small child)"
    },
    'ⲡⲟⲛⲏⲣⲟⲥ': {
      translation: "Mauvais, mauvaise",
      translationEn: "Bad, evil",
      explanation: "Adjectif qualificatif négatif",
      explanationEn: "Negative qualifying adjective",
      example: "ⲟⲩⲣⲱⲙⲓ ⲙ̀ⲡⲟⲛⲏⲣⲟⲥ (Un homme mauvais)",
      exampleEn: "ⲟⲩⲣⲱⲙⲓ ⲙ̀ⲡⲟⲛⲏⲣⲟⲥ (A bad man)"
    }
  },
  'Alphabet copte': {
    'ⲁ': {
      translation: "Alpha",
      translationEn: "Alpha",
      explanation: "Première lettre de l'alphabet copte, prononcée comme 'a' dans 'chat'",
      explanationEn: "First letter of the Coptic alphabet, pronounced like 'a' in 'father'",
      example: "ⲁⲛⲟⲕ (anok - je, moi)",
      exampleEn: "ⲁⲛⲟⲕ (anok - I, me)"
    },
    'ⲃ': {
      translation: "Vita (Beta)",
      translationEn: "Vita (Beta)",
      explanation: "Deuxième lettre de l'alphabet copte, prononcée comme 'v' ou 'b'",
      explanationEn: "Second letter of the Coptic alphabet, pronounced like 'v' or 'b'",
      example: "ⲃⲁⲗ (val - œil)",
      exampleEn: "ⲃⲁⲗ (val - eye)"
    },
    'ⲅ': {
      translation: "Gamma",
      translationEn: "Gamma",
      explanation: "Troisième lettre de l'alphabet copte, prononcée comme 'g' dans 'gare'",
      explanationEn: "Third letter of the Coptic alphabet, pronounced like 'g' in 'go'",
      example: "ⲅⲣⲁⲫⲏ (graphè - écriture)",
      exampleEn: "ⲅⲣⲁⲫⲏ (graphè - writing)"
    },
    'ⲇ': {
      translation: "Delta",
      translationEn: "Delta",
      explanation: "Quatrième lettre de l'alphabet copte, prononcée comme 'd' dans 'dire'",
      explanationEn: "Fourth letter of the Coptic alphabet, pronounced like 'd' in 'day'",
      example: "ⲇⲱⲣⲟⲛ (dôron - don)",
      exampleEn: "ⲇⲱⲣⲟⲛ (dôron - gift)"
    },
    'ⲉ': {
      translation: "Ei",
      translationEn: "Ei",
      explanation: "Cinquième lettre de l'alphabet copte, prononcée comme 'é' dans 'été'",
      explanationEn: "Fifth letter of the Coptic alphabet, pronounced like 'e' in 'they'",
      example: "ⲉⲓⲱⲧ (eiôt - père)",
      exampleEn: "ⲉⲓⲱⲧ (eiôt - father)"
    },
    'ⲍ': {
      translation: "Zeta",
      translationEn: "Zeta",
      explanation: "Sixième lettre de l'alphabet copte, prononcée comme 'z' dans 'zèbre'",
      explanationEn: "Sixth letter of the Coptic alphabet, pronounced like 'z' in 'zebra'",
      example: "ⲍⲱⲏ (zôè - vie)",
      exampleEn: "ⲍⲱⲏ (zôè - life)"
    },
    'ⲏ': {
      translation: "Eta",
      translationEn: "Eta",
      explanation: "Septième lettre de l'alphabet copte, prononcée comme 'è' long",
      explanationEn: "Seventh letter of the Coptic alphabet, pronounced as a long 'e'",
      example: "ⲏⲓ (èi - maison)",
      exampleEn: "ⲏⲓ (èi - house)"
    },
    'ⲑ': {
      translation: "Thêta",
      translationEn: "Theta",
      explanation: "Huitième lettre de l'alphabet copte, prononcée comme 'th' anglais dans 'think'",
      explanationEn: "Eighth letter of the Coptic alphabet, pronounced like the English 'th' in 'think'",
      example: "ⲑⲉⲟⲥ (theos - Dieu)",
      exampleEn: "ⲑⲉⲟⲥ (theos - God)"
    },
    'ⲓ': {
      translation: "Iota",
      translationEn: "Iota",
      explanation: "Neuvième lettre de l'alphabet copte, prononcée comme 'i' dans 'vie'",
      explanationEn: "Ninth letter of the Coptic alphabet, pronounced like 'i' in 'machine'",
      example: "ⲓⲥ (is - abréviation pour Jésus)",
      exampleEn: "ⲓⲥ (is - abbreviation for Jesus)"
    },
    'ⲕ': {
      translation: "Kappa",
      translationEn: "Kappa",
      explanation: "Dixième lettre de l'alphabet copte, prononcée comme 'k' dans 'képi'",
      explanationEn: "Tenth letter of the Coptic alphabet, pronounced like 'k' in 'kite'",
      example: "ⲕⲁⲥ (kas - os)",
      exampleEn: "ⲕⲁⲥ (kas - bone)"
    },
    'ⲗ': {
      translation: "Lambda",
      translationEn: "Lambda",
      explanation: "Onzième lettre de l'alphabet copte, prononcée comme 'l' dans 'lune'",
      explanationEn: "Eleventh letter of the Coptic alphabet, pronounced like 'l' in 'light'",
      example: "ⲗⲁⲥ (las - langue)",
      exampleEn: "ⲗⲁⲥ (las - tongue)"
    },
    'ⲙ': {
      translation: "Mi",
      translationEn: "Mi",
      explanation: "Douzième lettre de l'alphabet copte, prononcée comme 'm' dans 'main'",
      explanationEn: "Twelfth letter of the Coptic alphabet, pronounced like 'm' in 'mother'",
      example: "ⲙⲁⲁⲩ (maau - mère)",
      exampleEn: "ⲙⲁⲁⲩ (maau - mother)"
    },
    'ⲛ': {
      translation: "Ni",
      translationEn: "Ni",
      explanation: "Treizième lettre de l'alphabet copte, prononcée comme 'n' dans 'nom'",
      explanationEn: "Thirteenth letter of the Coptic alphabet, pronounced like 'n' in 'name'",
      example: "ⲛⲟⲩⲃ (noub - or)",
      exampleEn: "ⲛⲟⲩⲃ (noub - gold)"
    },
    'ⲝ': {
      translation: "Ksi",
      translationEn: "Ksi",
      explanation: "Quatorzième lettre de l'alphabet copte, prononcée comme 'ks' dans 'taxi'",
      explanationEn: "Fourteenth letter of the Coptic alphabet, pronounced like 'ks' in 'taxi'",
      example: "ⲝⲉⲛⲟⲥ (ksenos - étranger)",
      exampleEn: "ⲝⲉⲛⲟⲥ (ksenos - foreigner)"
    },
    'ⲟ': {
      translation: "O",
      translationEn: "O",
      explanation: "Quinzième lettre de l'alphabet copte, prononcée comme 'o' dans 'port'",
      explanationEn: "Fifteenth letter of the Coptic alphabet, pronounced like 'o' in 'port'",
      example: "ⲟⲩⲣⲟ (ouro - roi)",
      exampleEn: "ⲟⲩⲣⲟ (ouro - king)"
    },
    'ⲡ': {
      translation: "Pi",
      translationEn: "Pi",
      explanation: "Seizième lettre de l'alphabet copte, prononcée comme 'p' dans 'poire'",
      explanationEn: "Sixteenth letter of the Coptic alphabet, pronounced like 'p' in 'pear'",
      example: "ⲡⲓⲥⲧⲓⲥ (pistis - foi)",
      exampleEn: "ⲡⲓⲥⲧⲓⲥ (pistis - faith)"
    },
    'ⲣ': {
      translation: "Ro",
      translationEn: "Ro",
      explanation: "Dix-septième lettre de l'alphabet copte, prononcée comme 'r' roulé",
      explanationEn: "Seventeenth letter of the Coptic alphabet, pronounced as a rolled 'r'",
      example: "ⲣⲁⲛ (ran - nom)",
      exampleEn: "ⲣⲁⲛ (ran - name)"
    },
    'ⲥ': {
      translation: "Sima",
      translationEn: "Sima",
      explanation: "Dix-huitième lettre de l'alphabet copte, prononcée comme 's' dans 'sel'",
      explanationEn: "Eighteenth letter of the Coptic alphabet, pronounced like 's' in 'salt'",
      example: "ⲥⲱⲧⲙ (sôtm - écouter)",
      exampleEn: "ⲥⲱⲧⲙ (sôtm - to listen)"
    },
    'ⲧ': {
      translation: "Tau",
      translationEn: "Tau",
      explanation: "Dix-neuvième lettre de l'alphabet copte, prononcée comme 't' dans 'table'",
      explanationEn: "Nineteenth letter of the Coptic alphabet, pronounced like 't' in 'table'",
      example: "ⲧⲱⲃϩ (tôbh - prier)",
      exampleEn: "ⲧⲱⲃϩ (tôbh - to pray)"
    },
    'ⲩ': {
      translation: "Epsilon",
      translationEn: "Epsilon",
      explanation: "Vingtième lettre de l'alphabet copte, prononcée comme 'u' français ou 'y' en position finale",
      explanationEn: "Twentieth letter of the Coptic alphabet, pronounced like the French 'u' or like 'y' in final position",
      example: "ⲩⲓⲟⲥ (uios - fils)",
      exampleEn: "ⲩⲓⲟⲥ (uios - son)"
    },
    'ⲫ': {
      translation: "Phi",
      translationEn: "Phi",
      explanation: "Vingt-et-unième lettre de l'alphabet copte, prononcée comme 'ph' dans 'philosophie'",
      explanationEn: "Twenty-first letter of the Coptic alphabet, pronounced like 'ph' in 'philosophy'",
      example: "ⲫⲱⲃ (phôb - objet)",
      exampleEn: "ⲫⲱⲃ (phôb - object)"
    },
    'ⲭ': {
      translation: "Khi",
      translationEn: "Khi",
      explanation: "Vingt-deuxième lettre de l'alphabet copte, prononcée comme 'ch' allemand dans 'Bach'",
      explanationEn: "Twenty-second letter of the Coptic alphabet, pronounced like the German 'ch' in 'Bach'",
      example: "ⲭⲏⲣⲁ (khèra - veuve)",
      exampleEn: "ⲭⲏⲣⲁ (khèra - widow)"
    },
    'ⲯ': {
      translation: "Psi",
      translationEn: "Psi",
      explanation: "Vingt-troisième lettre de l'alphabet copte, prononcée comme 'ps' dans 'psychologie'",
      explanationEn: "Twenty-third letter of the Coptic alphabet, pronounced like 'ps' in 'psychology'",
      example: "ⲯⲩⲭⲏ (psukhè - âme)",
      exampleEn: "ⲯⲩⲭⲏ (psukhè - soul)"
    },
    'ⲱ': {
      translation: "Ô",
      translationEn: "O",
      explanation: "Vingt-quatrième lettre de l'alphabet copte, prononcée comme 'ô' long",
      explanationEn: "Twenty-fourth letter of the Coptic alphabet, pronounced as a long 'o'",
      example: "ⲱⲛϧ (ônkh - vie)",
      exampleEn: "ⲱⲛϧ (ônkh - life)"
    },
    'ϣ': {
      translation: "Shai",
      translationEn: "Shai",
      explanation: "Vingt-cinquième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'ch' dans 'chat'",
      explanationEn: "Twenty-fifth letter of the Coptic alphabet, specific to Coptic, pronounced like 'sh' in 'shop'",
      example: "ϣⲏⲣⲓ (shèri - fils)",
      exampleEn: "ϣⲏⲣⲓ (shèri - son)"
    },
    'ϥ': {
      translation: "Fai",
      translationEn: "Fai",
      explanation: "Vingt-sixième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'f' dans 'fin'",
      explanationEn: "Twenty-sixth letter of the Coptic alphabet, specific to Coptic, pronounced like 'f' in 'fine'",
      example: "ϥⲁⲓ (fai - porter)",
      exampleEn: "ϥⲁⲓ (fai - to carry)"
    },
    'ϧ': {
      translation: "Khai",
      translationEn: "Khai",
      explanation: "Vingt-septième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'kh' aspiré",
      explanationEn: "Twenty-seventh letter of the Coptic alphabet, specific to Coptic, pronounced as an aspirated 'kh'",
      example: "ϧⲉⲗⲗⲟ (khello - vieillard)",
      exampleEn: "ϧⲉⲗⲗⲟ (khello - old man)"
    },
    'ϩ': {
      translation: "Hori",
      translationEn: "Hori",
      explanation: "Vingt-huitième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'h' aspiré",
      explanationEn: "Twenty-eighth letter of the Coptic alphabet, specific to Coptic, pronounced as an aspirated 'h'",
      example: "ϩⲟ (ho - visage)",
      exampleEn: "ϩⲟ (ho - face)"
    },
    'ϫ': {
      translation: "Djandja",
      translationEn: "Djandja",
      explanation: "Vingt-neuvième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'dj' dans 'Djibouti'",
      explanationEn: "Twenty-ninth letter of the Coptic alphabet, specific to Coptic, pronounced like 'j' in 'Djibouti'",
      example: "ϫⲱⲙ (djôm - livre)",
      exampleEn: "ϫⲱⲙ (djôm - book)"
    },
    'ϭ': {
      translation: "Tchima",
      translationEn: "Tchima",
      explanation: "Trentième lettre de l'alphabet copte, spécifique au copte, prononcée comme 'tch' dans 'tchèque'",
      explanationEn: "Thirtieth letter of the Coptic alphabet, specific to Coptic, pronounced like 'ch' in 'check'",
      example: "ϭⲓϫ (tchidj - main)",
      exampleEn: "ϭⲓϫ (tchidj - hand)"
    },
    'ϯ': {
      translation: "Ti",
      translationEn: "Ti",
      explanation: "Trente-et-unième lettre de l'alphabet copte, spécifique au copte, combinaison de tau et iota",
      explanationEn: "Thirty-first letter of the Coptic alphabet, specific to Coptic, a combination of tau and iota",
      example: "ϯⲛⲟⲩ (tinou - maintenant)",
      exampleEn: "ϯⲛⲟⲩ (tinou - now)"
    }
  },
};

export default grammaire;

export {};
